import { create } from 'zustand';

interface AuthStore {
  // Wallet state
  walletAddress: string | null;
  isConnected: boolean;

  // Token state
  balance: number | null;
  isEligible: boolean;
  isCheckingBalance: boolean;

  // Session state
  sessionToken: string | null;
  signature: string | null;

  // Actions
  setWalletAddress: (address: string | null) => void;
  setIsConnected: (connected: boolean) => void;
  setBalance: (balance: number | null) => void;
  setIsEligible: (eligible: boolean) => void;
  setIsCheckingBalance: (checking: boolean) => void;
  setSessionToken: (token: string | null) => void;
  setSignature: (signature: string | null) => void;
  reset: () => void;
}

const initialState = {
  walletAddress: null,
  isConnected: false,
  balance: null,
  isEligible: false,
  isCheckingBalance: false,
  sessionToken: null,
  signature: null,
};

export const useAuthStore = create<AuthStore>((set) => ({
  ...initialState,

  setWalletAddress: (walletAddress) => set({ walletAddress }),
  setIsConnected: (isConnected) => set({ isConnected }),
  setBalance: (balance) => set({ balance }),
  setIsEligible: (isEligible) => set({ isEligible }),
  setIsCheckingBalance: (isCheckingBalance) => set({ isCheckingBalance }),
  setSessionToken: (sessionToken) => set({ sessionToken }),
  setSignature: (signature) => set({ signature }),
  reset: () => set(initialState),
}));
